export default __webpack_public_path__ + "static/media/grid_view_icon.6afd4962.svg";